import { Link, useRouterState } from '@tanstack/react-router'
import {
  Home, ListTodo, Calendar, User, Flame,
  Settings, Link2,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { APP_NAME } from '@/lib/constants'
import { KinkUpLogo } from '@/components/brand/KinkUpLogo'

const MAIN_NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: Home },
  { to: '/tasks', label: 'Tasks', icon: ListTodo },
  { to: '/calendar', label: 'Calendar', icon: Calendar },
  { to: '/feed', label: 'Feed', icon: Flame },
  { to: '/relationships', label: 'Relationships', icon: Link2 },
] as const

const BOTTOM_NAV = [
  { to: '/profile', label: 'Profile', icon: User },
  { to: '/settings', label: 'Settings', icon: Settings },
] as const

export function DesktopSidebar_M10_16() {
  const router = useRouterState()
  const currentPath = router.location.pathname

  return (
    <aside className="hidden lg:flex lg:flex-col lg:w-64 lg:h-screen lg:sticky lg:top-0 border-r border-white/5 bg-card/50 backdrop-blur-sm">
      {/* Brand */}
      <div className="p-6 pb-4">
        <Link to="/dashboard" className="flex items-center gap-2.5 group">
          <div className="flex items-center justify-center h-9 w-9 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/20 shadow-glow-sm">
            <KinkUpLogo size={22} />
          </div>
          <span className="font-display text-lg font-semibold text-gradient">
            {APP_NAME}
          </span>
        </Link>
      </div>

      {/* Main nav */}
      <nav className="flex-1 px-3 space-y-0.5">
        {MAIN_NAV.map(({ to, label, icon: Icon }) => {
          const active = currentPath.startsWith(to)
          return (
            <Link
              key={to}
              to={to}
              className={cn(
                'relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200',
                active
                  ? 'bg-primary/10 text-primary shadow-sm'
                  : 'text-muted-foreground hover:bg-white/5 hover:text-foreground'
              )}
            >
              {active && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-0.5 rounded-full bg-primary" />
              )}
              <Icon className="h-4 w-4" />
              {label}
            </Link>
          )
        })}
      </nav>

      {/* Bottom nav */}
      <div className="px-3 pb-4">
        <div className="h-px bg-white/5 mb-3" />
        {BOTTOM_NAV.map(({ to, label, icon: Icon }) => {
          const active = currentPath.startsWith(to)
          return (
            <Link
              key={to}
              to={to}
              className={cn(
                'flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200',
                active
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-white/5 hover:text-foreground'
              )}
            >
              <Icon className="h-4 w-4" />
              {label}
            </Link>
          )
        })}
      </div>
    </aside>
  )
}
